import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'
import Forward from 'react-icons/lib/md/arrow-forward'
import Back from 'react-icons/lib/md/arrow-back'
import { Fieldset, Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'
import RowSearch from 'bisu-react-row-search'

import InputCheckbox from 'components/InputCheckbox'
import { searchCourse } from 'containers/Courses/actions'
import { searchCurriculum } from 'containers/Curriculums/actions'
import { searchPaymentScheme } from 'containers/PaymentSchemes/actions'
import { searchScholarship } from 'containers/Scholarships/actions'

class StudentAdvising extends Component {

  componentWillMount() {
    // set full_name
    const { __model, dispatch } = this.props
    let fullName = __model.get('last_name') + ', ' + __model.get('first_name') + ' ' + __model.get('suffix_name')
    if (__model.get('middle_name')) {
      fullName += ' ' + __model.get('middle_name').charAt(0) + '.'
    }

    dispatch(actions.change('admissionState.full_name', fullName.toUpperCase()))
  }

  _back = () => {
    this.props.setStep(0)
  }

  _forward = () => {
    this.props.setStep(2)
  }

  render() {
    const {
      __resultCourses,
      __resultCurriculums,
      __resultPaymentSchemes,
      __resultScholarships,
    } = this.props

    return (
      <Panel header="Student Advising">
        <div className="m-b-20 row">
          <div className="col-sm-6">
            <button type="button" onClick={this._back} className="btn btn-warning"><Back /> Student Information</button>
          </div>
          <div className="col-sm-6 text-right">
            <button type="button" onClick={this._forward} className="btn btn-info">Set Student Account <Forward /></button>
          </div>
        </div>
        <hr />
        <Fieldset legend="Advising">
          <Row>
            <Field>
              <InputCheckbox
                model=".is_open"
                label="Is open for enrolment (Check this only if full-merit scholar)"
              />
            </Field>
          </Row>
          <Row>
            <Field span="1">
              <Input
                model=".level"
                label="Year Level"
                required
                autoFocus
              />
            </Field>
            <Field span="3" data-disabled="true">
              <Input
                model=".full_name"
                label="Student"
                disabled
              />
            </Field>
          </Row>
          <RowSearch
            placeholder="Search Course Code"
            label1="Course Code"
            label2="Course Name"
            model="admissionState.course_id"
            model1="admissionState.course_code"
            model2="admissionState.course_name"
            onSearch={searchCourse}
            searchResults={__resultCourses}
            required
          />
          <RowSearch
            placeholder="Search Curriculum Code"
            label1="Curriculum Code"
            label2="Curriculum Name"
            model="admissionState.curriculum_id"
            model1="admissionState.curriculum_code"
            model2="admissionState.curriculum_name"
            onSearch={searchCurriculum}
            onFinish={this._focusNext}
            searchResults={__resultCurriculums}
            required
          />
          <RowSearch
            placeholder="Search PaymentScheme Code"
            label1="PaymentScheme Code"
            label2="PaymentScheme Name"
            model="admissionState.paymentscheme_id"
            model1="admissionState.paymentscheme_code"
            model2="admissionState.paymentscheme_name"
            onSearch={searchPaymentScheme}
            searchResults={__resultPaymentSchemes}
            required
          />
          <RowSearch
            placeholder="Search Scholarship Code"
            label1="Scholarship Code"
            label2="Scholarship Name"
            model="admissionState.scholarship_id"
            model1="admissionState.scholarship_code"
            model2="admissionState.scholarship_name"
            onSearch={searchScholarship}
            searchResults={__resultScholarships}
          />
        </Fieldset>
      </Panel>
    )
  }
}

StudentAdvising.propTypes = {
  __model: PropTypes.object,
  __resultCourses: PropTypes.object,
  __resultCurriculums: PropTypes.object,
  __resultPaymentSchemes: PropTypes.object,
  __resultScholarships: PropTypes.object,
  setStep: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __model: state.admissionState,
    __resultCourses: state.sccourse.get('list'),
    __resultCurriculums: state.curriculum.get('list'),
    __resultPaymentSchemes: state.paymentscheme.get('list'),
    __resultScholarships: state.scscholarship.get('list'),
  }
}

export default connect(mapStateToProps)(StudentAdvising)



// WEBPACK FOOTER //
// ./src/containers/Admission/student-advising.js